import React from 'react'
import VendorNav from '../../Components/Vendor/VendorNav/VendorNav'
import AddStudios from '../../Components/Vendor/VendorStudios/AddStudios'
import Footer from '../../Components/Vendor/Footer/Footer'

function AddstudioPage() {
  return (
    <div>
      <VendorNav/> 
      <AddStudios/>
      <Footer/>
    </div>
  )
}

export default AddstudioPage
